import { PasswordField } from 'src/pages/channel/shared';

export const TelegramFields = ({ t }: any) => (
  <PasswordField
    name="telegramBotToken"
    label={t('TELEGRAM_BOT_TOKEN')}
    placeholder={t('ENTER_TELEGRAM_BOT_TOKEN')}
  />
);
